export default class ResponseError extends Error {
  name
  response: Response | null
  statusCode: number | null
  correlationId
  constructor(response: Response | null, correlationId: string) {
    super()
    this.statusCode = response?.status ?? null
    this.name = response?.statusText ?? ""
    this.response = response
    this.correlationId = correlationId
    Object.setPrototypeOf(this, ResponseError.prototype)
  }
}
